import {
  IConstraint,
  IOptimizationConstraintsState,
} from '@/interfaces/portfolioOptimization.interface'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

// Define the initial state
export const initialState: IOptimizationConstraintsState = {
  isExpanded: false,
  isComplete: false,
  template: {
    id: '',
    description: '',
    constraints: [],
  },
}

export const optimizationConstraintSlice = createSlice({
  name: 'optimizationConstraint',
  initialState,
  reducers: {
    toggleExpanded: (state) => {
      state.isExpanded = !state.isExpanded
    },
    setComplete: (state, action: PayloadAction<boolean>) => {
      state.isComplete = action.payload
    },
    resetConstraints: (state) => {
      state.isExpanded = false
      state.isComplete = false
      state.template = {
        id: '',
        description: '',
        constraints: [],
      }
    },
    setConstraint: (state, action: PayloadAction<IConstraint[]>) => {
      state.template.constraints = action.payload
    },
    addConstraint: (state, action: PayloadAction<IConstraint>) => {
      state.template.constraints.push({ ...action.payload, rowKey: uuidv4() })
    },
    removeConstraint: (state, action: PayloadAction<string>) => {
      state.template.constraints = state.template.constraints.filter(
        (constraint) => constraint.rowKey !== action.payload,
      )
    },
    updateTemplate: (
      state,
      action: PayloadAction<Partial<IOptimizationConstraintsState['template']>>,
    ) => {
      state.template = {
        ...state.template,
        ...action.payload,
      }
    },
  },
})

export const {
  toggleExpanded,
  setComplete,
  resetConstraints,
  setConstraint,
  addConstraint,
  removeConstraint,
  updateTemplate,
} = optimizationConstraintSlice.actions

export default optimizationConstraintSlice.reducer
